<template>
  <div class="bottomDefalt" v-loading="loading">
    <div class="bottomDefalt-top">
      <div
        :class="
          energyType === 'ac'
            ? 'bottomDefalt-top-left ashComWrap'
            : 'bottomDefalt-top-leftWarm ashComWrap'
        "
      >
        <div class="comTitle borderRaduis10">
          <h4>能耗指标</h4>
        </div>
        <div
          :class="
            energyType === 'ac'
              ? 'comContentBox'
              : 'comContentBox bottomDefalt-top-leftWarm-content'
          "
        >
          <HeadTipsGroup
            v-if="energyType === 'ac' && eciData?.length"
            :listData="eciData"
            twoLine
          />
          <template v-else-if="energyType !== 'ac' && eciWarmData?.length">
            <HeadTipsGroup :listData="eciWarmData[0]" />
            <HeadTipsGroup :mutipleData="eciWarmData[1]" useMutipleParams />
          </template>
          <el-empty v-else class="empty" description="暂无数据"></el-empty>
        </div>
      </div>
      <div
        :class="
          energyType === 'ac'
            ? 'bottomDefalt-top-right ashComWrap'
            : 'bottomDefalt-top-rightWarm ashComWrap'
        "
      >
        <div class="comTitle borderRaduis10">
          <h4>能效指标</h4>
        </div>
        <div
          :class="
            energyType === 'ac'
              ? 'comContentBox bottomDefalt-top-rightWarm-content'
              : 'comContentBox bottomDefalt-top-right-content'
          "
        >
          <HeadTips
            v-if="energyType === 'ac' && eeiData?.length"
            :listData="eeiData"
            twoLine
            className="eeiHeadTips"
          />
          <DataPagination
            v-else-if="energyType !== 'ac' && eeiWarmData?.length"
            :listData="eeiWarmData"
            className="eeiWarmDataSwitch"
            useEfficiencyStyle
            :chartsId="assetId"
            :split-num="4"
          />
          <el-empty v-else class="empty" description="暂无数据"></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataPagination from "@/components/zixitong/airSystem/DataPagination.vue";
import HeadTips from "@/components/HeadTips/HeadTips";
import HeadTipsGroup from "@/components/HeadTips/HeadTipsGroup";
import PublicEcharts from "@/components/PublicEcharts";
import api from "@/api";
import { getProjectVal } from "@/assets/js/utils";
export default {
  components: { HeadTips, HeadTipsGroup, PublicEcharts, DataPagination },
  name: "BottomDefault",
  props: {
    assetId: {
      type: String,
      default: "",
    },
    //模式， gc - 燃气制热， ec - 电制热， ac - 空气源热泵制热
    energyType: {
      type: String,
      default: "ac",
    },
  },
  data() {
    return {
      hostLoad: [], //主机负荷
      eciData: [], //能耗
      eciWarmData: [], //能耗
      eeiData: [], //能效
      eeiWarmData: [],
      loading: false,
    };
  },
  methods: {
    initData() {
      this.hostLoad = []; //主机负荷
      this.eciData = []; //能耗
      this.eciWarmData = []; //能耗
      this.eeiData = []; //能效
      this.eeiWarmData = []; //能效
    },
    dealWarmEEI(data = []) {
      const newData = data.map((element) => {
        const obj = { nameDefault: "锅炉" };
        Array.isArray(element) &&
          element.forEach((item) => {
            const { name: childName = "", value, unit } = item;
            switch (childName) {
              case "name":
                obj.name = value;
                break;
              case "等效热功率":
                obj.realName = "等效热功率";
                obj.realValue = value;
                obj.realUnit = unit;
                break;
              case "效率":
                obj.echartsData = { name: childName, value };
                break;
              default:
                break;
            }
          });
        return obj;
      });
      return newData;
    },
    //能效指标
    //制热模式
    async getHeatingEnergyEfficiencyIndicators(assetId = null) {
      return await api.DHWGetHeatingEnergyEfficiencyIndicators({
        projectId: getProjectVal("Id"),
        assetId: assetId,
        deviceType: "锅炉,空气源热泵",
        energyType: this.energyType,
      });
    },
    dealWarmECI(data = []) {
      const newData = [[], { name: "锅炉机组", params: [] }];
      data.forEach((element) => {
        const { name, params = [] } = element;
        if (["锅炉机组","空气源热泵机组"].includes(name)) {
          const obj1 = {};
          const obj2 = {};
          //燃气
          if (this.energyType === "gc") {
            Array.isArray(params) &&
              params.forEach((item) => {
                const { name: childName = "", value, unit } = item;
                switch (childName) {
                  case "实时用气量":
                    obj1.realName = childName;
                    obj1.realValue = value;
                    obj1.realUnit = unit;
                    break;
                  case "机组实时效率":
                    obj1.rateName = childName;
                    obj1.rateValue = value;
                    obj1.rateUnit = unit;
                    break;
                  case "实时热量":
                    obj2.realName = childName;
                    obj2.realValue = value;
                    obj2.realUnit = unit;
                    break;
                  case "今日供热量":
                    obj2.rateName = childName;
                    obj2.rateValue = value;
                    obj2.rateUnit = unit;
                    break;
                  default:
                    break;
                }
              });
          } else {
            Array.isArray(params) &&
              params.forEach((item) => {
                const { name: childName = "", value, unit } = item;
                switch (childName) {
                  case "实时功率":
                    obj1.realName = childName;
                    obj1.realValue = value;
                    obj1.realUnit = unit;
                    break;
                  case "负荷率":
                    obj1.rateName = childName;
                    obj1.rateValue = value;
                    obj1.rateUnit = unit;
                    break;
                  case "实时热量":
                    obj2.realName = childName;
                    obj2.realValue = value;
                    obj2.realUnit = unit;
                    break;
                  case "今日供热量":
                    obj2.rateName = childName;
                    obj2.rateValue = value;
                    obj2.rateUnit = unit;
                    break;
                  default:
                    break;
                }
              });
          }
          newData[1].params = [obj1, obj2];
        } else {
          const obj = { name };
          Array.isArray(params) &&
            params.forEach((item) => {
              const { name: childName = "", value, unit } = item;
              if (childName.includes("实时")) {
                obj.realName = childName;
                obj.realValue = value;
                obj.realUnit = unit;
              } else {
                obj.rateName = childName;
                obj.rateValue = value;
                obj.rateUnit = unit;
              }
            });
          newData[0].push(obj);
        }
      });
      return newData;
    },
    //能耗指标
    //制热模式
    async getHeatingEnergyConsumptionIndicators(assetId = null) {
      return await api.DHWGetHeatingEnergyConsumptionIndicators({
        projectId: getProjectVal("Id"),
        assetId: assetId,
        deviceType: "锅炉,空气源热泵",
        energyType: this.energyType,
      });
    },
    getData(assetId) {
      this.loading = true;
      this.initData();
      const q1 = this.getHeatingEnergyEfficiencyIndicators(assetId);
      const q2 = this.getHeatingEnergyConsumptionIndicators(assetId);
      Promise.all([q1, q2])
        .then((res) => {
          let res1 = res[0];
          if (res1 && res1.data.code == 200) {
            this.eeiWarmData = this.dealWarmEEI(res1.data.data);
          } else {
            console.log("获取能效指标失败");
          }
          let res2 = res[1];
          if (res2 && res2.data.code == 200) {
            this.eciWarmData = this.dealWarmECI(res2.data.data);
          } else {
            console.log("获取能耗指标失败");
          }
        })
        .catch((err) => {
          console.log("---getData---err----", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    assetId: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        console.log("bottomDefault---assetId--", val, oldVal);
        // this.getHeatingEnergyEfficiencyIndicators(val)
        // this.getEnergyConsumptionIndicators(val)
        // this.getHostLoad(val)
        this.getData(val);
      },
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.bottomDefalt {
  width: 100%;
  margin-top: 12px;
  @include setFlexColumn;
  // height: 450px;

  &-top {
    @include setFlexBetween;
    height: 450px;

    &-left {
      flex-grow: 1;
      width: 1218px;
      margin-right: 12px;
    }

    &-right {
      width: 370px;
      flex-grow: 0;

      &-content {
        padding: 0 5px;
        width: calc(100% - 10px);
      }

      ::v-deep .eeiHeadTips > div .firstDiv .highlight {
        font-size: 22px;
      }
    }
    &-leftWarm {
      flex-grow: 1;
      width: calc(50% - 6px);
      margin-right: 12px;
      &-content {
        @include setFlexColumn;
        justify-content: space-around;
      }
    }

    &-rightWarm {
      width: calc(50% - 6px);
      flex-grow: 1;

      &-content {
        padding: 0 5px;
        width: calc(100% - 10px);
      }

      ::v-deep .eeiHeadTips > div .firstDiv .highlight {
        font-size: 22px;
      }
      ::v-deep .eeiWarmDataSwitch {
        height: 395px;
      }
    }
  }
  .borderRaduis10 {
    border-radius: 10px;
  }
}
</style>
